module.exports = __webpack_public_path__ + "static/img/nowPolicexc.54f70b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nowPolicexc.png
// module id = AGBF
// module chunks = 208